import { Button, Box } from "@mui/material";
import SubmitButton from "../../buttons";
import { LoginState, useLogin } from "../context";
import { LoadingSpinner } from "../../loading";
import { Link } from "react-router-dom";
import { useState } from "react";
import { TextInput } from "../../forms/TextInput";

export const OneTimePassword = () => {
  const { loginState } = useLogin();

  if (loginState == LoginState.ONETIMECODE) return <EnterOneTimePassword />;
  else if (loginState == LoginState.OTPFIRST) return <EnterOneTimePassword />;

  return <></>;
};

const EnterOneTimePassword = () => {
  const {
    verifyOneTimeCode,
    setPasscode,
    submitting,
    error,
    maskedPhone,
    loginState,
    resendOneTimeCode,
  } = useLogin();
  const [termsAgreed, setTermsAgreed] = useState(false);
  const [showTermsError, setShowTermsError] = useState(false);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();

        if (loginState == LoginState.OTPFIRST && !termsAgreed) {
          setShowTermsError(true);
          return;
        } else {
          setShowTermsError(false);
        }

        verifyOneTimeCode();
      }}
    >
      <h1 className={"nhsuk-u-font-size-32"} style={{ marginBottom: "16px" }}>
        Two-factor authentication
      </h1>

      <p className={"nhsuk-u-font-size-19"}>
        Your account is protected with two-factor authentication. We've sent you
        a text message. Please enter code below
      </p>

      {loginState == LoginState.OTPFIRST && (
        <p>
          The code has been sent to number ending {maskedPhone}. If this number
          is incorrect, please contact the service.
        </p>
      )}

      <div
        className={
          error
            ? "nhsuk-form-group nhsuk-form-group--error"
            : "nhsuk-form-group"
        }
      >
        <label className="nhsuk-label" htmlFor="email">
          Two-Factor Code
        </label>
        {error && (
          <div className="nhsuk-field">
            <legend className="nhsuk-fieldset__legend nhsuk-fieldset__legend--l">
              <span className="nhsuk-error-message">{error}</span>
            </legend>
          </div>
        )}
        <TextInput
          inputWidth={300}
          inputType="number"
          onChange={(e: any) => setPasscode(e.target.value)}
          enabled={true}
        />
      </div>

      {loginState == LoginState.OTPFIRST && (
        <div
          className={
            showTermsError
              ? "nhsuk-form-group nhsuk-form-group--error"
              : "nhsuk-form-group"
          }
        >
          <fieldset className="nhsuk-fieldset" style={{marginTop:"32px"}}>
            {showTermsError && (
              <div className="nhsuk-field">
                <legend className="nhsuk-fieldset__legend nhsuk-fieldset__legend--l">
                  <span className="nhsuk-error-message">
                    You must agree to the terms and conditions and privacy
                    policy
                  </span>
                </legend>
              </div>
            )}
            <div className="nhsuk-checkboxes">
              <div className="nhsuk-checkboxes__item">
                <input
                  className="nhsuk-checkboxes__input"
                  id={"terms"}
                  name={"terms"}
                  type="checkbox"
                  onChange={(e) => setTermsAgreed(e.target.checked)}
                />
                <label
                  className="nhsuk-label nhsuk-checkboxes__label"
                  htmlFor={"terms"}
                >
                  I consent to the use of my personal data in accordance with
                  the Mental Health Online Privacy Policy and to the Terms and
                  Conditions.
                  <div>
                    <Link
                      style={{ marginRight: ".5rem" }}
                      to={"/privacy-policy"}
                      target="_blank"
                    >
                      Privacy Policy
                    </Link>
                    <Link to={"/terms-and-conditions"} target="_blank">
                      Terms and Conditions
                    </Link>
                  </div>
                </label>
              </div>
            </div>
          </fieldset>
        </div>
      )}

      {submitting && <LoadingSpinner />}
      {!submitting && (
        <SubmitButton content={<>Continue</>} style={{ marginLeft: 0 }} />
      )}

      <Box>
        {!submitting && (
          <Button
            variant={"text"}
            style={{ textTransform: "none", margin: 0, padding: 0 }}
            onClick={() => resendOneTimeCode()}
          >
            Resend code via text message &gt;
          </Button>
        )}
      </Box>
    </form>
  );
};
